import React from 'react';

interface EnterGray400IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const EnterGray400Icon: React.FC<EnterGray400IconProps> = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 11.6667C2.5 11.4457 2.5878 11.2337 2.74408 11.0774C2.90036 10.9212 3.11232 10.8334 3.33333 10.8334H13.3333C13.9964 10.8334 14.6323 10.57 15.1011 10.1011C15.5699 9.63228 15.8333 8.99639 15.8333 8.33335V5.00002C15.8333 4.77901 15.9211 4.56705 16.0774 4.41076C16.2337 4.25448 16.4457 4.16669 16.6667 4.16669C16.8877 4.16669 17.0996 4.25448 17.2559 4.41076C17.4122 4.56705 17.5 4.77901 17.5 5.00002V8.33335C17.5 9.43842 17.061 10.4982 16.2796 11.2796C15.4982 12.061 14.4384 12.5 13.3333 12.5H3.33333C3.11232 12.5 2.90036 12.4122 2.74408 12.2559C2.5878 12.0997 2.5 11.8877 2.5 11.6667Z"
        fill="#888888"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74399 12.2558C2.58776 12.0996 2.5 11.8876 2.5 11.6667C2.5 11.4457 2.58776 11.2338 2.74399 11.0775L6.07732 7.74418C6.23449 7.59238 6.44499 7.50839 6.66349 7.51029C6.88199 7.51218 7.091 7.59982 7.2455 7.75433C7.40001 7.90884 7.48765 8.11785 7.48955 8.33635C7.49145 8.55484 7.40745 8.76534 7.25566 8.92251L4.51149 11.6667L7.25566 14.4108C7.33525 14.4877 7.39873 14.5797 7.44241 14.6813C7.48608 14.783 7.50907 14.8924 7.51003 15.003C7.51099 15.1137 7.48991 15.2234 7.44801 15.3258C7.40611 15.4282 7.34423 15.5213 7.26598 15.5995C7.18774 15.6778 7.0947 15.7396 6.99228 15.7815C6.88987 15.8234 6.78014 15.8445 6.66949 15.8436C6.55884 15.8426 6.44949 15.8196 6.34782 15.7759C6.24615 15.7323 6.15419 15.6688 6.07732 15.5892L2.74399 12.2558Z"
        fill="#888888"
      />
    </svg>
  );
};
